module.exports = __webpack_public_path__ + "assets/c0fc710950b22c6bf8681900c63490c4.png";